import React, { Component } from 'react'

export default class Grievaneces extends Component {
    render() {
        return (
            <div>
                <h5>Grievaneces</h5>
            </div>
        )
    }
}
